/* global mainScript */
import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { motion } from "framer-motion";

// style rules
import { Animation } from "../../styles";

const ResourceCard = ({ resource }) => {
	const renderCategories = () => {
		const categoryTitles = resource.categories.map(
			(category) => category.title
		);
		const categoriesParagraph = categoryTitles.join(", ");

		return (
			<p className="card-resource__content__category">{categoriesParagraph}</p>
		);
	};
	return (
		<Card
			initial={"initial"}
			animate={"animate"}
			exit={"initial"}
			variants={Animation.cards.opacityVariants}
			key={resource.id}
			className="card-resource"
		>
			<div className="card-resource__image-container">
				{resource.image ? (
					<img src={resource.image} alt={`Image for ${resource.title}`} />
				) : (
					<img
						src={
							mainScript.assetPath +
							"images/png/graphics/resources-placeholder@2x.png"
						}
						alt={"News Card placeholder"}
						className="placeholder-image"
					/>
				)}
			</div>
			<div className="card-resource__content">
				{resource.categories.length > 0 && renderCategories()}
				<a href={resource.url}>
					<h3
						className="card-resource__content__title"
						dangerouslySetInnerHTML={{ __html: resource.title }}
					/>
				</a>
			</div>
		</Card>
	);
};

export default ResourceCard;

ResourceCard.propTypes = {
	resource: PropTypes.object,
};

const Card = styled(motion.li)``;
